import { create } from 'zustand';
import { auth, type User } from '@/lib/api';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  fetchMe: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('acs_token'),
  login: async (email, password) => {
    set({ isLoading: true });
    try {
      const { access_token, user } = await auth.login(email, password);
      localStorage.setItem('acs_token', access_token);
      set({ user, isAuthenticated: true, isLoading: false });
    } catch (e) {
      set({ isLoading: false });
      throw e;
    }
  },
  logout: async () => {
    try { await auth.logout(); } catch { /* ignore */ }
    localStorage.removeItem('acs_token');
    set({ user: null, isAuthenticated: false });
  },
  fetchMe: async () => {
    if (!localStorage.getItem('acs_token')) return;
    try {
      const user = await auth.me();
      set({ user, isAuthenticated: true });
    } catch {
      localStorage.removeItem('acs_token');
      set({ user: null, isAuthenticated: false });
    }
  },
}));
